/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AssetsUploadMutationRequest, AssetsUploadMutationResponse, AssetsUpload401, AssetsUpload403 } from "../models/AssetsUpload";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { assetsUpload } from "../axios/assetsUpload";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const assetsUploadMutationKey = () => [{ url: '/assets/v1' }] as const

export type AssetsUploadMutationKey = ReturnType<typeof assetsUploadMutationKey>

export function assetsUploadMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AssetsUploadMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = assetsUploadMutationKey()
        return mutationOptions<AssetsUploadMutationResponse, ResponseErrorConfig<AssetsUpload401 | AssetsUpload403>, {data: AssetsUploadMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return assetsUpload(data, config)
          },
        })

}

/**
 * @summary Upload asset
 * {@link /assets/v1}
 */
export function useAssetsUpload<TContext>(options: 
{
  mutation?: UseMutationOptions<AssetsUploadMutationResponse, ResponseErrorConfig<AssetsUpload401 | AssetsUpload403>, {data: AssetsUploadMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AssetsUploadMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? assetsUploadMutationKey()

          const baseOptions = assetsUploadMutationOptions(config) as UseMutationOptions<AssetsUploadMutationResponse, ResponseErrorConfig<AssetsUpload401 | AssetsUpload403>, {data: AssetsUploadMutationRequest}, TContext>
          

          return useMutation<AssetsUploadMutationResponse, ResponseErrorConfig<AssetsUpload401 | AssetsUpload403>, {data: AssetsUploadMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AssetsUploadMutationResponse, ResponseErrorConfig<AssetsUpload401 | AssetsUpload403>, {data: AssetsUploadMutationRequest}, TContext>
      
}